import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateHabilidadesListaColumns
 */

type Props = {
  onActionEdit: (idHabilidade: number | null, openState: boolean) => void,
  onActionDelete: (idHabilidade: number | null, openState: boolean) => void,
};

export const GenerateHabilidadesListaColumns = ({
  onActionEdit,
  onActionDelete,
}: Props): GridColDef[] => {
  return [
    {
      field: "nome",
      filterable: false,
      headerName: "Nome",
      minWidth: 150,
      width: 300,
      sortable: false,
      renderCell: ({ value }) => {
        return (<div className="w-full h-full flex items-center py-1">{value}</div>);
      }
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: ({ value }) => {
        return (<div className="w-full h-full flex items-center py-1">{value}</div>);
      }
    },
    {
      field: 'acoes',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      valueGetter: (_, row) => row['idHabilidade'] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEdit(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDelete(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}